import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Moment from 'react-moment';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { setCurrentSection } from '../../actions/globalConfig';
import { formatNumber } from '../../utils';
import { fetchMemberProfile } from '../../actions/memberProfile';
import {
  EditProfileView,
  FavoriteLivecams,
  FavoriteSnapshotsView,
  Loader,
  MemberSnapshotsView,
} from '../../components';
import './style.scss';
import NotificationsSection from './NotificationsSection';
import CommentsSection from './CommentsSection';
import { clearNotifications } from '../../actions/currentUser';
import FollowUser from './FollowUser';

const propTypes = {
  statusText: PropTypes.string,
  userName: PropTypes.string,
  sectionName: PropTypes.string,
  profileImage: PropTypes.string,
  userId: PropTypes.string,
};

const defaultProps = {
  sectionName: 'Profile',
  statusText: '',
  userName: '',
  userId: null,
  profileImage: 'https://explore.org/images/icon_avatar_default.png'
};

const sections = {
  profile: 'profile',
  comments: 'comments',
  notifications: 'notifications',
};

class MemberProfile extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      editProfile: false,
      currentSection: sections.profile,
    };
    this.editProfile = this.editProfile.bind(this);
    this.cancelEditing = this.cancelEditing.bind(this);
    this.setSection = this.setSection.bind(this);
  }

  componentWillMount() {
    let username = this.props.params.username;
    if (username) {
      this.props.getMemberProfile(username);
    }
    this.props.setTheSection(this.props.sectionName);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.params.username !== nextProps.params.username) {
      this.props.getMemberProfile(nextProps.params.username);
    }

    if (this.props.userId !== nextProps.userId) {
      this.setSection(sections.profile);
    }
  }

  componentDidMount() {
    const { routeParams: { section } } = this.props;
    if (section) {
      this.setSection(section);
    }
    setTimeout(function () {
      window.dispatchEvent(new CustomEvent('checkImageLazyload'));
    }, 3000);
  }

  componentDidUpdate() {
    window.dispatchEvent(new CustomEvent('checkImageLazyload'));
  }

  editProfile() {
    this.setState({ editProfile: true });
  }

  setSection(section) {
    this.setState({ currentSection: section });
  }

  renderSliders(user) {
    let profileHasData = true;
    const currentUsersProfile = this.props.userId === user.id;
    if (_.every([user.favorites.livecams, user.favorites.snapshots, user.snapshots], (arr) => {
      return (!_.isArray(arr) || arr.length === 0);
    })) {
      profileHasData = false;
    }

    if (profileHasData) {
      return (
        <div>
          <FavoriteLivecams
            livecams={user.favorites.livecams}
            username={this.props.params.username}
            belongsToCurrentUser={currentUsersProfile}
          />
          <FavoriteSnapshotsView snapshots={user.favorites.snapshots}/>
          <MemberSnapshotsView
            snapshots={user.snapshots}
            count={user.snapshots_count}
            username={this.props.params.username}
          />
        </div>
      );
    }
    return (
      <div className="row">
        <div className="col-12 bg-fff-50 border-grey mb-30">
          <h2 className="no-user-info">There has been no activity to report for this member.</h2>
        </div>
      </div>
    );
  }

  renderNoUserResponse() {
    return (
      <div id="member-page" className="transition-item">
        <div className="container-fluid content">
          <div className="row">
            <div className="col-12 bg-fff-50 border-grey">
              <h2 className="no-user-info">We could not find user {this.props.params.username}</h2>
            </div>
          </div>
        </div>
      </div>
    );
  }

  cancelEditing() {
    this.setState({ editProfile: false });
  }

  render() {
    const { user, isFetching, userId, token, clearNotifications, unreadNotifications } = this.props;
    const { editProfile, currentSection } = this.state;
    if (isFetching) {
      return (<div style={{ marginTop: 200, marginBottom: 200 }}><Loader ref="loader" dark style={{ minHeight: 100 }}/>
      </div>);
    }

    if (!user || _.isEmpty(user)) {
      return this.renderNoUserResponse();
    }

    const username = user.username;
    const profileImage = (user.avatar_uri) ? user.avatar_uri : this.props.profileImage;

    let ctaButton = null;
    let displayName = (user.display_name && !_.isEmpty(user.display_name)) ? user.display_name : username;
    const currentUsersProfile = this.props.userId === user.id;
    if (currentUsersProfile) {
      ctaButton = (
        <div className="header-button" onClick={this.editProfile}>
          Edit Profile Information
        </div>
      );
    } else {
      ctaButton = (
        <Fragment>
          <FollowUser username={username} />
          <div className="header-button hidden">
            Send a message
          </div>
        </Fragment>
      );
    }

    if (currentUsersProfile && editProfile) return (<EditProfileView closeForm={this.cancelEditing} />);
    const profileSection = () => {
      if (this.state.currentSection === sections.profile) {
        return (
          <Fragment>
            <div className="vital-stats row">
              <span className="col">
                Joined | <Moment format="L">{user.date_joined}</Moment>
              </span>
              <span className="col">
                Last Visited | <Moment format="L">{user.last_login}</Moment>
              </span>
              <span className="col">
                Snapshots | {formatNumber(user.snapshots_count)}
              </span>
            </div>
            {this.renderSliders(user)}
          </Fragment>
        );
      }

      if (currentSection === sections.notifications) {
        return (<NotificationsSection token={token} clearNotifications={clearNotifications} unreadNotifications={unreadNotifications} />);
      }

      if (currentSection === sections.comments) {
        return (<CommentsSection token={token} username={currentUsersProfile ? undefined : username} />);
      }

      return (<div>{currentSection}</div>);
    };
    return (
      <div id="member-page">
        <div className="container-fluid content">
          <div className="row bg-fff-80 border-grey">
            <div className="member-info col-auto">
              <img className="member-image" src={profileImage} />
            </div>
            <div className="col">
              <div className="align-items-start d-flex flex-column h-100">
                <div className="pt-1">
                  <h1 className="member-title">{displayName}</h1>
                </div>
                <div className="mt-auto">
                  <ul className="nav nav-tabs">
                    <li className="nav-item">
                      <button
                        className={classNames(['nav-link', 'mb-0', {active: currentSection === sections.profile}])}
                        onClick={() => this.setSection(sections.profile)}
                      >
                        Favorites & Snapshots
                      </button>
                    </li>
                    {!!currentUsersProfile && (
                      <li className="nav-item">
                        <button
                          className={classNames(['nav-link', 'mb-0', {active: currentSection === sections.notifications}])}
                          onClick={() => this.setSection(sections.notifications)}
                        >
                          Notifications
                        </button>
                      </li>
                    )}
                    {!!token && (
                      <li className="nav-item">
                        <button
                          className={classNames(['nav-link', 'mb-0', {active: currentSection === sections.comments}])}
                          onClick={() => this.setSection(sections.comments)}
                        >
                          Comment History
                        </button>
                      </li>
                    )}
                  </ul>
                </div>
              </div>
            </div>
            <div className="member-info col-auto">
              {ctaButton}
            </div>
          </div>
          {profileSection()}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userId: state.auth.userId,
    userName: state.auth.userName,
    token: state.auth.commentToken,
    statusText: state.auth.statusText,
    isFetching: state.memberProfile.isFetching,
    user: state.memberProfile.data,
    dataToggle: state.memberProfile.dataToggle,
    unreadNotifications: state.currentUser.unreadNotifications,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    clearNotifications: () => dispatch(clearNotifications()),
    getMemberProfile: (username) => dispatch(fetchMemberProfile(username)),
    setTheSection: (sectionName) => dispatch(setCurrentSection(sectionName)),
  };
};

MemberProfile.propTypes = propTypes;
MemberProfile.defaultProps = defaultProps;

export default connect(mapStateToProps, mapDispatchToProps)(MemberProfile);
